module.exports = __webpack_public_path__ + "static/media/segEle.c57f093f.png";